<template lang="html">
<div>
    <div class="c-inner">
        <div class="det-lists" :style="'height:' + innerH + 'px'">
              <div ref="el" class="list-inner">
                    <div class="song-text">
                         <div class="author-line">
                              <div class="">作词：</div>
                              <div class="">{{infos | getText('作词')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">作曲：</div>
                              <div class="">{{infos | getText('作曲')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">演唱：</div>
                              <div class="">{{infos | getText('演唱')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">演奏：</div>
                              <div class="">{{infos | getText('演奏')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">录制时间：</div>
                              <div class="">{{infos | getClassify('录制时间')}}</div>
                         </div>
                    </div>
                    <div class="song-text">
                         <div class="author-line">
                              <div class="">类名：</div>
                              <div class="">{{infos | getText('音乐分类')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">语种：</div>
                              <div class="">{{infos | getClassify('语种')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">编制：</div>
                              <div class="">{{infos | getClassify('编制')}}</div>
                         </div>
                         <div class="author-line">
                              <div class="">主题词：</div>
                              <div class="">{{infos | getClassify('主题词')}}</div>
                         </div>
                    </div>
                    <div class="song-text">
                         <div class="author-line">
                             <div class="">声音格式：</div>
                             <div class="">PCM WAV</div>
                         </div>
                         <div class="author-line">
                             <div class="">取样率：</div>
                             <div class="">96KHZ</div>
                         </div>
                         <div class="author-line">
                             <div class="">播放设备：</div>
                             <div class="">{{infos | getClassify('播放设备')}}</div>
                         </div>
                         <div class="author-line">
                             <div class="">取样单元：</div>
                             <div class="">24bit</div>
                         </div>
                    </div>
                    <div class="song-text">
                         <div class="author-line">唱词/歌词</div>
                         <div class="author-line" v-for="(item,index) in lyrics" :key="index">{{item.lyric}}</div>
                    </div>
              </div>
        </div>
    </div>
    <div class="author-more" @click="moreTap">
          <span v-if="listState">收起</span>
          <span v-else>查看单曲详细信息</span>
          <van-icon :class="['icon',{'act':listState}]" class-prefix="iconfont" name="slideOpen" />
    </div>
</div>
</template>

<script>
export default {
    props:['songDat','lyrics'],
    computed:{
        infos:function(){
             if(this.songDat.info){
                  return JSON.parse(this.songDat.info);
             }else{
                 return ''
            }
        }
    },
    filters:{
        getText:function(e,key){
            if(e){
                if(e[key]){
                    if(e[key][0]['显示']){
                        let names = '';
                        for(let i = 0;i < e[key].length;i++){
                            names = names + ',' + e[key][i]['显示'];
                        }
                        return names.substr(1,names.length);
                    }else{
                        if(key == '音乐分类'){
                            let arrs = e[key].split(',');
                            return arrs[arrs.length - 1];
                        }else{
                            return e[key];
                        }
                    }
                }else{
                    return '/';
                }
            }
        },
        getClassify:function(e,key){
            if(e){
                return e[key] || '/'
            }
        }
    },
    data(){
        return {
            innerH:145,
            listState:false
        }
    },
    methods:{
        moreTap:function(){
            this.listState = !this.listState;
            this.listState ? this.innerH = this.$refs.el.offsetHeight:this.innerH = 145;
        }
    }
}
</script>

<style lang="css" scoped>

/* 主题信息 */

.det-lists{
   position: relative;
   overflow: hidden;

   transition-property: all;
   transition-duration: 0.2s;
}

.song-text{
   background: white;
   padding: 12px;
   margin-top: 6px;
}

.song-text .author-line{
   font-size: 14px;
   line-height: 24px;
   color: #666666;
   display: flex;
   align-items: flex-start;
}

.song-text .author-line div:first-child{
   flex-shrink: 0;
}

.author-more{
   padding-top: 6px;
   text-align: center;
   background: white;
   padding-bottom: 12px;
}

.author-more span{
  font-size: 14px;
  color: #666666;
  display: inline-block;
}

.author-more .icon{
  position: relative;
  font-size: 21px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 3px;

  transition-property: all;
  transition-duration: 0.2s;
  -webkit-transform: rotate(0deg);
}

.author-more .icon.act{
  -webkit-transform: rotate(180deg);
}
</style>
